import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function AdminShell() {
  const { profile, isAdmin } = useAuth();
  return (
    <div className="admin">
      <a href="#admin-main" className="skip-link">Skip to content</a>
      <nav aria-label="Admin" className="admin-nav">
        <NavLink to="/admin" end className="brand">
          <img src="/blueline-seal.png" alt="" width={36} height={36} />
          <span><strong>BlueLine</strong><br />{isAdmin ? 'Admin' : 'Instructor'}</span>
        </NavLink>
        <NavLink to="/admin" end>Dashboard</NavLink>
        <NavLink to="/admin/courses">Courses</NavLink>
        <NavLink to="/admin/students">Students</NavLink>
        <NavLink to="/">View as student</NavLink>
        <span style={{ marginTop: 'auto', padding: '16px 12px 4px', borderTop: '1px solid rgba(255,255,255,.18)', fontSize: 13, color: '#dbe7f3' }}>
          {profile?.full_name || 'Signed in'}
        </span>
      </nav>
      <main id="admin-main" className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
